const s = {
  name: "FormulaPickUpThePhone",
  dimensions: { width: 24, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 40" style="enable-background:new 0 0 24 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.5,5.5C13.5,6.3,12.8,7,12,7c-0.8,0-1.5-0.7-1.5-1.5C10.5,4.7,11.2,4,12,4C12.8,4,13.5,4.7,13.5,5.5z"/>
		<path class="st0" d="M7.5,15.5C6.7,15.5,6,16.2,6,17H4c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5H9C9,16.2,8.3,15.5,7.5,15.5z"
			/>
		<path class="st0" d="M12,25c-2.8,0-5-2.2-5-5H5c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7h-2C17,22.8,14.8,25,12,25z"/>
		<path class="st0" d="M13,17c0-1.9,1.6-3.5,3.5-3.5S20,15.1,20,17h-2c0-0.8-0.7-1.5-1.5-1.5S15,16.2,15,17H13z"/>
		<path class="st0" d="M8,36h8v-2H8V36z"/>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v30c0,2.8,2.2,5,5,5h14c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5c0-1.7,1.3-3,3-3h14
			c1.7,0,3,1.3,3,3v30c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FormulaPickUpThePhone
};
